import { isString } from '@vnxjs/shared'

import Swan from './program'

import type { IPluginContext } from '@vnxjs/service'

// Allow other platform plugins to inherit this
export { Swan }

export default (ctx: IPluginContext) => {
  ctx.registerPlatform({
    name: 'swan',
    useConfigName: 'mini',
    async fn ({ config }) {
      const program = new Swan(ctx, config)
      await program.start()
    }
  })

  ctx.modifyRunnerOpts(({ opts }) => {
    if (!opts?.compiler) return

    if (isString(opts.compiler)) {
      opts.compiler = {
        type: opts.compiler
      }
    }
    const { compiler } = opts
    if (compiler.type === 'webpack5') {
      compiler.prebundle ||= {}
      const prebundleOptions = compiler.prebundle
      if (prebundleOptions.enable === false) return
      prebundleOptions.swc ||= {
        jsc: {
          // Note: Because the 100-degree program doesn't support it. ES2015，That's why we need a general here. ES5 (There's no problem with the simulator environment.)
          target: 'es5'
        }
      }
      prebundleOptions.exclude ||= []
      prebundleOptions.include ||= []
    }
  })
}
